import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiManualSharingSelectionInfoContainerComponent } from './fi-manual-sharing-selection-info-container.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [CommonModule, MatIconModule],
    declarations: [FiManualSharingSelectionInfoContainerComponent],
    exports: [FiManualSharingSelectionInfoContainerComponent],
})
export class FiManualSharingSelectionInfoContainerModule {}
